function shouldHideVariant(variantData, articleType) {
  if (!variantData) {
    return false;
  }

  const articleStatus = variantData.artikelstatus;
  const inventoryPolicy = variantData.inventoryPolicy;
  const inventoryQuantity = variantData.inventoryQuantity;

  if (articleStatus === 'EOL'
      && ['dropshipment', 'dropshipping', 'longtail (info-artikel)', 'longtail (article d\'information)'].includes(articleType)
      && inventoryPolicy !== 'continue') {
    return true;
  }

  if (['EOL', 'UL', 'UD', 'R0', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9'].includes(articleStatus)
      && articleType === 'xxl'
      && inventoryQuantity <= 0) {
    return true;
  }

  return false;
}
